import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { module } from 'app/modules/equipment-registration/equipment-registration.module';
import { EquipRegistrationServices } from 'app/modules/equipment-registration/services/equipment-registration.service';

@Component({
  selector: 'app-update-historical-data',
  standalone: true,
  imports: module,
  templateUrl: './update-historical-data.component.html',
  styleUrl: './update-historical-data.component.scss'
})
export class UpdateHistoricalDataComponent {
  form: any
  public wrsvTypleList: []

  constructor(
    public dialogRef: MatDialogRef<UpdateHistoricalDataComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _formBuilder: UntypedFormBuilder,
    private _changeDetectorRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private equipmentServices: EquipRegistrationServices,
  ) { }


  ngOnInit() {
    this.form = this.initForm(this.data.valveName)

    this.form.get('actuatorType')?.valueChanges.subscribe((type: string) => {
      this.resetInactiveActuatorFields(type);
    });

    if (this.valveGroup === 'wrsv') {
      this.getTypeWrsvList()
    }
  }

  private resetInactiveActuatorFields(actuatorType: string, targetForm: FormGroup = this.form): void {
    if (!targetForm) return;

    if (actuatorType === 'Pneumatic') {
      targetForm.patchValue({
        fullyOpen: null,
        fullyClose: null,
        hydraulicReturn: null,
      }, { emitEvent: false });
    } else if (actuatorType === 'Manual') {
      targetForm.patchValue({
        actuatorModel: null,
        openingSec: null,
        openingCm: null,
        closingSec: null,
        closingCm: null,
        hydraulicReturn: null,
      }, { emitEvent: false });
    } else if (actuatorType === 'Hydraulic') {
      targetForm.patchValue({
        actuatorModel: null,
        openingSec: null,
        openingCm: null,
        closingSec: null,
        closingCm: null,
        fullyOpen: null,
        fullyClose: null,
      }, { emitEvent: false });
    } else {
      targetForm.patchValue({
        actuatorModel: null,
        openingSec: null,
        openingCm: null,
        closingSec: null,
        closingCm: null,
        fullyOpen: null,
        fullyClose: null,
        hydraulicReturn: null,
      }, { emitEvent: false });
    }
  }

  private readonly VALVE_GROUPS: Record<string, string> = {
    'Xmas Tree': 'xmasTree',
    'Crown Valve': 'standard',
    'King Wing Valve': 'standard',
    'Lower Master Valve': 'standard',
    'Surface Safety Valve': 'standard',
    'Wing Valve': 'standard',
    'Annulus Valve A': 'annulus',
    'Annulus Valve B': 'annulus',
    'Annulus Valve C': 'annulus',
    'Annulus Valve D': 'annulus',
    'TR-SSSV': 'trsssv',
    'WRSV': 'wrsv',
  };

  get valveGroup(): string {
    return this.VALVE_GROUPS[this.data.valveName] ?? 'default';
  }

  private initForm(valveName: string): FormGroup {
    console.log(valveName)
    const group = this.VALVE_GROUPS[valveName] ?? 'default';

    console.log(group)

    const common = {
      id: [null],
      wellStringId: [null],
      installedDate: [null],
      equipmentBrand: [null],
      inputBy: [null],
      inputDate: [null],
      partNo: [null],
      sizeIn: [null],
      ratingPsi: [null],
      model: [null],
      remark: [null],
    };

    const actuatorFields = {
      mdSceValveTypeId: [null],
      sceXmasTreeId: [null],
      actuatorType: [null],
      actuatorModel: [null],
      openingCm: [null],
      openingSec: [null],
      closingCm: [null],
      closingSec: [null],
      fullyClose: [null],
      fullyOpen: [null],
      hydraulicReturn: [null],
    };

    const xmassTreeFields = {
      treecapConn: [null],
      treeCapConnSize: [null],
      treecapConnRemarks: [null],
      treeCapConnThread: [null],
      treeCapDescription: [null],
    };

    let form: FormGroup;

    switch (group) {
      case 'xmasTree':
        form = this._formBuilder.group({ ...common, ...xmassTreeFields });

          // set initial state based on current value
  this.toggleTreecapConnRemarks(form.get('treecapConn').value, form);

  // react to future changes
  form.get('treecapConn').valueChanges.subscribe((value: string) => {
    this.toggleTreecapConnRemarks(value, form);
  });

        break;

      case 'standard':
        form = this._formBuilder.group({ ...common, ...actuatorFields });
        break;

      case 'annulus':
        form = this._formBuilder.group({
          ...common,
          ...actuatorFields,
          isAvrInstalled: [null],
        });
        break;

      case 'trsssv':
        form = this._formBuilder.group({
          ...common,
          mdSssvTypeId: [null],
          isSelfEqualize: [null],
          isLockedOpen: [null],
        });
        break;

      case 'wrsv':
        form = this._formBuilder.group({
          id: [null],
          scssvId: [null],
          initialInstalledDate: [null],
          latestInstalledDate: [null],
          trsvType: [null],
          sizeIn: [null],
          partNo: [null],
          subsequentInstalledDate: [null],
          equipmentBrand: [null],
          ratingPsi: [null],
          model: [null],
          installationDepth: [null],
          installationAtSvlntrsv: [null],
          remark: [null],
        });
        break;

      default:
        form = this._formBuilder.group(common);
        break;
    }

    console.log(this.data.row)

    // Patch in existing row data, if any
    if (this.data.row) {
      form.patchValue(this.data.row);
    }

    if (form.get('actuatorType')) {
      this.resetInactiveActuatorFields(form.get('actuatorType')?.value, form);
    }

    return form;
  }

  onUpdate() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const actuatorType = this.form.get('actuatorType')?.value;
    if (actuatorType) {
      this.resetInactiveActuatorFields(actuatorType);
    }

    const payload = this.form.getRawValue();

    this.equipmentServices.updateHistoricalData(this.data.valveName, payload)
      .subscribe({
        next: (response) => {
          // e.g. close dialog, show success toast
          this.dialogRef.close(response);
        },
        error: (err) => {
          // show error toast
          console.error(err);
        }
      });
  }

  private getTypeWrsvList() {
    this.equipmentServices.getSssvType().subscribe(res => {
      this.wrsvTypleList = res
    })
  }

  formatDecimal(value: number | null | undefined): void {
    if (value === null || value === undefined || isNaN(value)) {
      this.form.get('').treeCapConnSize = null;
      return;
    }
  }

  private toggleTreecapConnRemarks(value: string, form: FormGroup): void {
  const remarksControl = form.get('treecapConnRemarks');
  if (value === 'OTHERS') {
    remarksControl.enable();
  } else {
    remarksControl.disable();
    remarksControl.setValue(null); // optional: clear stale value when disabled
  }
}
}
